import React, { Component } from "react";
import PropTypes from 'prop-types';
import classnames from "classnames";
import Checkbox from '../Checkbox/Checkbox';

//import css
import "./styles.css";

export default class GroupCheckBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedBoxesIdArray:
        this.props.checkedBoxes.map(chkBox => {
          return chkBox.id;
        }) || []
    };
  }

  componentWillReceiveProps(nextProps) {
    let _chkBoxIdArr = nextProps.checkedBoxes.map(chkBox => {
      return chkBox.id;
    });
    this.setState({
      checkedBoxesIdArray: _chkBoxIdArr || []
    });
    if (this.props.checkedBoxes !== nextProps.checkedBoxes) {
      let _chkBoxIdArr = nextProps.checkedBoxes.map(chkBox => {
        return chkBox.id;
      });
      this.setState({
        checkedBoxesIdArray:
          nextProps.checkedBoxes.map(chkBox => {
            return chkBox.id;
          }) || []
      });
    }
  }

  handleChange = (id, name) => e => {
    let eventObject = {
      id,
      name,
      type: "groupCheckBoxChange",
      isChecked: e.target.checked,
      checkBoxGroup: this.props.checkBoxName
    };
    if (this.props.allSelectorValue && this.props.allSelectorPosition) {
      if (
        id.split(":")[this.props.allSelectorPosition] ===
        this.props.allSelectorValue
      ) {
        eventObject.allCheckedFlag = true;
      }
    }
    this.props.handleOnChange(eventObject);
  };

  renderSingleCheckBoxItem = chkBoxItem => {
    let isBoxChecked = this.state.checkedBoxesIdArray.includes(chkBoxItem.id);
    return (
      <div
        className="gdocs-group-checkbox-single-checkbox-main-div"
        key={`${this.props.checkBoxName}_${chkBoxItem.id}`}
      >
        <Checkbox
          onChange={this.handleChange(chkBoxItem.id, chkBoxItem.name)}
          id={chkBoxItem.id}
          name={`${this.props.checkBoxName}_${chkBoxItem.name}_${this.props.checkBoxIndex}`}
          checked={isBoxChecked}
          controlled
        />
        <label
          htmlFor={chkBoxItem.name}
          className="product-enablement-text"
          style={{marginLeft:'1rem'}}
        >
          {chkBoxItem.name || 'Unlabelled Checkbox'}
        </label>
      </div>
    );
  };

  renderCheckBoxes = () => {
    let _renderJsx = this.props.checkBoxData.associations.map(
      (chkBox, boxIdx) => {
        return this.renderSingleCheckBoxItem(chkBox);
      }
    );
    return _renderJsx;
  };

  render() {
    const groupCheckBoxMainDiv = classnames("gdocs-group-checkbox-main-div");
    const groupCheckBoxComponentMainDiv = classnames("gdocs-group-checkbox-components-main-div");
    const groupCheckBoxLabelMainDiv = classnames("gdocs-group-checkbox-label-main-div");
    return (
        this.props.checkBoxData.id !== undefined ?
      <fieldset className={groupCheckBoxMainDiv} key={`${this.props.checkBoxName}_${this.props.checkBoxData.id.split(':')[10]}`}>
        <legend className={groupCheckBoxLabelMainDiv}>
          {this.props.checkBoxData.name}
        </legend>
        <div className={groupCheckBoxComponentMainDiv}>
          {this.renderCheckBoxes()}
        </div>
      </fieldset>
    : '' );
  }
}

GroupCheckBox.propTypes = {
  checkBoxData: PropTypes.object.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  checkedBoxes: PropTypes.array.isRequired,
  allSelectorValue: PropTypes.string,
  allSelectorPosition: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/components/common/GroupedCheckBox/GroupedCheckBox.js